import { UntypedFormGroup } from '@angular/forms';
import {
    ColumnMode,
    DatatableComponent,
    TableColumn,
} from '@swimlane/ngx-datatable';

/** Datatable */
export interface Datatable<T> {
    page: DatatablePage;
    column: DatatableColumn<T>;
    rows: T[];
}

export interface DatatablePage {
    size: number;
    offset: number;
    totalRecords: number;
    totalPages: number;
}

export interface DatatableColumn<T> {
    mode: ColumnMode;
    header?: DatatableColumnHeader<T>[];
}

export interface DatatableColumnHeader<T> {
    key: string;
    name: string;
    props: TableColumn;
    render?(data: T, index: number, dt: Datatable<T>): any;
}

export interface NgxDatatable<T> {
    searchForm: UntypedFormGroup;
    dt: Datatable<T>;
    element: DatatableComponent;
    onInit(): void;
    onSearch(): void;
    onReset(): void;
    onSort(sort): void;
    onPage(input: any): void;
    onSize(size: number): void;
    onDestroy(): void;
    onRefresh(): void;
}

export interface NgxDatatableConfig<T> {
    config: {
        page?: DatatablePage;
        column: DatatableColumn<T>;
        rows?: T[];
    };
    searchForm: any;
    onPage: any;
    element?: DatatableComponent;
    parentElement?: any;
}
/** Datatable */

/** Request */
export interface PaginateRequest {
    Page: number;
    PageSize: number;
    OrderBy: string;
    OrderDir: string;
}

export interface SearchableRequest extends PaginateRequest {
    WellName: string;
    StringName: string;
    FieldName: string;
}
/** Request */

/** Response */
export interface Response<T> {
    isSuccess: boolean;
    message: string;
    statusCode: string;
    data: T;
}

export interface PaginateResponse<T> {
    data: T[];
    totalPages: number;
    totalRecords: number;
    size: number;
    current: number;
}
/** Response */

/** SearchableRequest */

export interface FieldSearchableRequest {
    fieldLongName?: string;
    fieldShortName?: string;
}

export interface PlatformSearchableRequest {
    platformName?: string;
}

export interface WellSearchableRequest {
    wellLongName?: string;
    wellShortName?: string;
}

export interface StringSearchableRequest {
    wellStringLongName?: string;
    wellStringShortName?: string;
    stringName?: string;
    wellLongName?: string;
    platformName?: string;
}

/** SearchableRequest */

export interface OptionItem {
    id: string;
    optionId: string;
    name: string;
    alternate: string;
    inputDate: string;
    inputBy: string;
    updateDate: string;
    updateBy: string;
    option: any;
    isDeleted: boolean;
}
